// extracted by mini-css-extract-plugin
export var actionButton = "_f6-t";
export var buttonContainer = "_f6-0";
export var buttonContainer2 = "_f6-1";
export var buttonSection = "_f6-2";
export var details = "_f6-3";
export var dropdownItem = "_f6-5";
export var dropdownItemsContainer = "_f6-4";
export var fileInput = "_f6-r";
export var headerButton = "_f6-6";
export var icon = "_f6-7";
export var input = "_f6-8";
export var macroListItem = "_f6-9";
export var mainContent = "_f6-a";
export var microText = "_f6-b";
export var modal = "_f6-w";
export var optionsButton = "_f6-c";
export var paperclip = "_f6-s";
export var pillContent = "_f6-d";
export var preview = "_f6-e";
export var preview2 = "_f6-f";
export var quillEditor = "_f6-q";
export var selectedMacro = "_f6-g";
export var sidebar = "_f6-h";
export var sidebarHeader = "_f6-j";
export var sidebarList = "_f6-i";
export var sidebarListItem = "_f6-k";
export var sidebarSearch = "_f6-l";
export var snoozeDurationWrapper = "_f6-v";
export var statusPillContainer = "_f6-m";
export var tagsContainer = "_f6-n";
export var unselectedMacro = "_f6-o";
export var variable = "_f6-u";
export var wrapper = "_f6-p";